exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width:600px)  {\n.base-modal .modal-body {\r\n    height: 100%;\r\n    overflow: scroll !important;\r\n    border-radius: 0px;\n}\n}\r\n\r\n", ""]);

// exports
